import { ErrorMessage } from 'formik';
import React from 'react';
import Select from 'react-select';
import { useBlockitTheme } from '../../themes/useTheme';

/**
 * @deprecated
 */
export const MultiSelect = ({
  className,
  onChange,
  onBlur,
  options,
  value,
  name,
  label,
  touched,
  errors,
  isMulti,
  ...rest
}) => {
  const { isAlluvium, branding } = useBlockitTheme();

  name = `${name}`;

  const alluviumTheme = isAlluvium
    ? base => ({
        ...base,
        colors: {
          ...base.colors,
          primary: branding.primaryColor,
          primary75: branding.primaryColorHover,
          primary50: '#f5f3f3',
          primary25: '#f5f3f3',
        },
      })
    : undefined;

  return (
    <React.Fragment>
      <div className="mt-2">
        <label className="text-label" htmlFor={name}>
          {label}
        </label>
        <Select
          key={name}
          isMulti={isMulti || false}
          isSearchable
          onChange={val => onChange(name, val)}
          onBlur={() => onBlur(name, true)}
          value={value}
          options={options}
          name={name}
          className={className.concat(touched[name] && errors[name] ? ' border border-red' : '') + ' mt-2 rounded'}
          {...rest}
          theme={alluviumTheme}
          style={{ ':focus': '#8795a1' }}
        />
        <div className="text-red text-xs">
          <ErrorMessage name={name}>{() => 'Required'}</ErrorMessage>
        </div>
      </div>
    </React.Fragment>
  );
};
